import React from "react";

const Java_DataTypes_Var = () => {
  return (
    <div>
      <h1>Java DataTypes Var</h1>
      <p>This page provides explanations, examples, and common use-cases for Java DataTypes Var in Java.</p>
    </div>
  );
};

export default Java_DataTypes_Var;
